import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as PageService from './../services/pageService';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import {notification} from 'antd'
import {
    setListPages as setListPagesAction,
    setPageDetail as setPagesDetailAction,
} from './../actions/pageAction';
import history from './../helpers/history';

function* getListPage() {
    yield takeLatest(Types.PAGE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const pageSize = action.filters.pageSize ? action.filters.pageSize > 10 ? action.filters.pageSize : undefined : undefined;
        const pageIndex = action.filters.pageIndex ? action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined : undefined;
        const params = {
            ...action.filters,
            pageSize, pageIndex,
        };
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(PageService.getPages, params);
        yield put(setListPagesAction(result));
    }, errorHandlePage(Types.PAGE_LIST_FAIL)))
}

function* getPageDetail() {
    yield takeLatest(Types.PAGE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PageService.getPageDetail, action.id);
        yield put(setPagesDetailAction(result));
    }, errorHandlePage(Types.PAGE_DETAIL_FAIL)))
}

function* updatePageDetail() {
    yield takeLatest(Types.PAGE_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PageService.updatePageDetail, action.page.page);
        Func.sagaSuccessMessage({ action,
            message: `${i18n.t('notification.updateSuccess')}`,
            description: `${i18n.t('item.page.title_page')} "${action.page.page.title}"`
        })
        yield put(setPagesDetailAction(result));
        history.push(PATHS.PAGE.LIST.path);
        history.go();
    }, errorHandlePage(Types.PAGE_DETAIL_FAIL)))
}

function* createPageDetail() {
    yield takeLatest(Types.PAGE_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PageService.createPageDetail, action.page);
        Func.sagaSuccessMessage({ action,
            message: `${i18n.t('notification.createSuccess')}`,
            description: `${i18n.t('item.page.title_page')} "${action.page.title}"`
        })
        history.push(PATHS.PAGE.LIST.path);
        history.go();
        yield put(setPagesDetailAction(result));
    }, errorHandlePage(Types.PAGE_DETAIL_FAIL)))
}

function* deletePageDetail() {
    yield takeLatest(Types.PAGE_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PageService.deletePageDetail, action.page);
        Func.sagaSuccessMessage({ action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = {
            ...action.filters,
            PageIndex: action.filters.pageIndex && action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined,
            PageSize: action.filters.pageSize && action.filters.pageSize > 10 ? action.filters.pageSize : undefined,
        };
        const resultList = yield call(PageService.getPages, params);
        yield put(setListPagesAction(resultList));
    }, errorHandlePage(Types.PAGE_DETAIL_FAIL)));
}

// TRANSLATE
function* createPageTranslate() {
    yield takeLatest(Types.PAGE_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(PageService.createPageTranslate, action.page);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.page.translate.languageName);
        yield put({ type: Types.PAGE_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.PAGE_DETAIL_ACTION, id: action.page.id });
    }, errorHandlePage(Types.PAGE_FAIL)))
}

function* updatePageTranslate() {
    yield takeLatest(Types.PAGE_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(PageService.updatePageTranslate, action.page);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.page.translate.languageName);
        yield put({ type: Types.PAGE_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.PAGE_DETAIL_ACTION, id: action.page.id });
    }, errorHandlePage(Types.PAGE_FAIL)))
}

function* deletePageTranslate() {
    yield takeLatest(Types.PAGE_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(PageService.deletePageTranslate, action.page.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.page.translate.languageName);
        yield put({ type: Types.PAGE_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.PAGE_DETAIL_ACTION, id: action.page.id });
    }, errorHandlePage(Types.PAGE_FAIL)))
}

function errorHandlePage(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'page');
}

export function* pageSaga() {
    yield all([
        fork(getListPage),
        fork(getPageDetail),
        fork(updatePageDetail),
        fork(createPageDetail),
        fork(deletePageDetail),

        fork(createPageTranslate),
        fork(updatePageTranslate),
        fork(deletePageTranslate),
    ])
}
